<template>
	<div>
		<van-uploader v-model="fileList" :max-count="6" :after-read="afterRead" :before-delete="beforeDelete">
			<div class="uploadwechatdiv">
				<van-icon name="plus" size="24" />
				<p>
					上传图片

				</p>
			</div>
		</van-uploader>
	</div>
</template>

<script>
	var root = process.env.VUE_APP_API_URL;

	import {
		Uploader,
		Toast,
		Icon
	} from "vant";
	import Compressor from 'compressorjs';
	export default {
		components: {
			[Uploader.name]: Uploader,
			[Toast.name]: Toast,
			[Icon.name]: Icon
		},

		data() {
			return {
				getUploadUrl: root + "upload/index",
				fileList: [],
				pictures: []
			};
		},
		props: {
			type: String 
		},
 
		mounted() {},

		methods: {
			initFile(images,pictures){
				if(pictures){
					this.pictures = pictures
					this.fileList = []
					images.forEach((item)=>{
						console.log(item)
						this.fileList.push({
							url:item,
							name:new Date().getTime()
						})
					})
				}
				
			},
			compressor(file) {
				return new Promise(function(resolve, reject) {
					new Compressor(file, {
						quality: 0.6,
						maxWidth: 750,
						success(result) {
							let newFile = new File([result], file.name, {
								type: file.type
							})
							resolve(newFile)
						},
						error(err) {
							console.log(err.message);
						},
					});
				})

			},
			afterRead(file, detail) {

				if (file instanceof Array) {
					this.upload(file, 0);
				} else {
					var arr = [];
					arr.push(file);
					this.upload(arr, 0);
				}
			},
			async upload(fileList, i) {
				var self = this;
				if (fileList.length == i) {
					self.$toast.clear();
					self.$emit("change", self.pictures);
					return;
				}
				self.$toast.loading({
					mask: true,
					duration: 0,
					message: "第" + (i + 1) + "张上传中"
				});
				var file = fileList[i];
				let result = await this.compressor(file.file)
				var formData = new FormData();
				formData.append("file", result);
				self.src = file.content;
				formData.append("name", file.file.name);
				$.ajax({
					url: self.getUploadUrl,
					async: true,
					timeout: 120000,
					dataType: "json",
					type: "post",
					data: formData,
					processData: false, // 不处理数据
					contentType: false, // 不设置内容类型
					headers: self.getRequestHeader(),
					success: function(reponseData, status) {
						console.log(reponseData)
						self.pictures.push(reponseData.url);
						i++;
						self.upload(fileList, i);
					},
					error: function() {
						self.$toast("system error");
					}
				});


			},
			del(file) {},
			beforeDelete(obj,file) {
		 
				this.pictures.splice(file.index, 1);
				this.$emit("change", this.pictures);
				return true;
			}
		}
	};
</script>
<style>
	.uploadwechatdiv {
		border: #eee 1px dashed;
		width: 80px;
		height: 80px;
		border-radius: 4px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #888;
		flex-direction: column;
		position: relative;
		overflow: hidden;
		font-size: 12px;
		background-color: #f8f8f8
	}
</style>
<style scoped>
	.form-box-tag {
		background-color: #f8f8f8;
		line-height: 32px;
		text-align: center;
		color: #555;
		border-radius: 4px;
		cursor: pointer;
	}

	.form-box-tag.active {
		background-color: #feefe9;
		color: #f56229;
	}

	.uploadwechatdiv {
		border: #eee 1px dashed;
		width: 80px;
		height: 80px;
		border-radius: 4px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #888;
		flex-direction: column;
		position: relative;
		overflow: hidden;
		font-size: 12px;
		background-color: #f8f8f8
	}
</style>>